.file-manager {
  max-height: calc(95vh - 40px); // Modal vh limit and minus padding
  display: grid;
  grid-template-rows: auto auto minmax(0, 1fr);
}


.geojson {
  &__section {
    padding: 8px 48px;
  }

  /* === Info Section === */
  &__info-wrapper {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  &__info-label {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    flex: 1 0 0;
    min-width: 200px;
  }

  &__info-heading {
    font-size: 1.125rem;
    font-weight: 500;
  }

  &__info-subheading {
    color: var(--mm-text-text-secondary, #61646B);
  }

  &__info-value {
    display: flex;
    padding: 4px 16px;
    align-items: center;
    gap: 12px;
    border-radius: var(--radius-md);
    border: 1px solid var(--mm-gray-3, var(--color-border-primary));
    background: #FFF
  }

  &__cloud-icon {
    transform: scale(1.4);
    color: var(--mm-blue, #000);
  }

  &__storage {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 4px;

    &-values {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    &-files-size {
      color: var(--mm-text-text-secondary, #61646B);
      font-size: 1rem;
    }

    &-files-amount {
      color: var(--mm-gray-4, #94979E);
      font-size: 0.75rem;
    }
  }

  /* === Upload Section === */
  &__upload {
    display: flex;
    flex-direction: column;
    gap: 4px;

    &-hint {
      display: flex;
      flex-direction: column;
      gap: 4px;
      font-size: 0.875rem;
      color: var(--mm-text-text-secondary, #61646B);
    }
  }

  /* === Uploaded Files Section === */
  &__uploaded-files {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
    overflow-y: auto;
  }

  &__heading {
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 500;
  }

  &__files-list {
    display: flex;
    padding: 24px 0px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    align-self: stretch;

    border-radius: var(--radius-md);
    border: 1px solid var(--color-border-primary);
    //height: 60vh; // TODO: change to part of whole

    &--empty {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 8px;
      color: var(--mm-text-text-secondary, #61646B);
      font-weight: 400;
      font-style: normal;
      font-size: 0.875rem;
    }
  }

  &__table {

    min-height: 200px;
    width: 100%;

    &-loading {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
    }

    &-actions-cell {
      position: relative;
    }

    &-delete-button {
      opacity: 0 !important;
      pointer-events: none !important;
      transition: opacity 0.2s ease-in-out;
      background: none;
      color: var(--System-Red-500, #EB4143);
    }

    :global(.ag-row-hover) &-delete-button {
      opacity: 1 !important;
      pointer-events: auto !important;
    }

  }
}


.msg__success {
  display: flex;
  align-items: center;
  gap: 20px;
  font-size: 0.875rem;

  &__icon {
    color: #36D398
  }
}

.msg__warning {
  display: flex;
  align-items: center;
  gap: 20px;
  font-size: 0.875rem;
}

.msg__error {
  display: flex;
  align-items: center;
  gap: 20px;
  font-size: 0.875rem;

  &__icon {
    color: #F87172
  }
}
